(function () {
  'use strict';

  if (window.BloomingfulCombinedListingsGuardVersion) return;
  window.BloomingfulCombinedListingsGuardVersion = '2026-08-10-active-products-only';

  var activeHandles = window.BloomingfulActiveProductHandles || {};
  var optionSelector = '.mpg-swatch__option[onclick*="redirectToProductPage"]';
  var scheduled = false;

  function handleFromOption(option) {
    var source = option.getAttribute('onclick') || '';
    var match = source.match(/redirectToProductPage\(\s*['"]([^'"]+)['"]/);
    return match ? match[1] : '';
  }

  function removeInactiveOptions() {
    scheduled = false;
    if (!Object.keys(activeHandles).length) return;
    document.querySelectorAll(optionSelector).forEach(function (option) {
      var handle = handleFromOption(option);
      if (handle && !activeHandles[handle]) option.remove();
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(removeInactiveOptions);
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
